module.exports = __webpack_public_path__ + "img/bg103_3.64507d16.png";